import gql from 'graphql-tag';
import { clients } from '../../../util/clients';
import { fieldsToGqlString, mergeByIdNewAtTop } from '../../../util/shared/vue-global';

const { backend } = clients.direct;

const fields = {
  _id: '',
  assessorTaxDistrictCode: '',
  taxDistrictCode: '',
  taxDistrictDescription: '',
  assessorLevies: '',
  treasuresLevies: '',
};

export const assessorXRefActions = {
  async loadAssessorXRefRecords({ commit, dispatch }, {
    baseCrudKey, criteria, postProcessTrans,
  }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.query({
        query: gql` query accessorXRef($criteria: accessorXRefCriteriaType) {
          accessorXRef(criteria: $criteria) {
            ${fieldsToGqlString(fields)},
            }
          }`,
        variables: { criteria },
        fetchPolicy: 'no-cache',
      });
      clients.handleGQLErrors(results, commit);
      if (results.data) {
        const { accessorXRef } = results.data;
        const processedTransData = postProcessTrans
          ? postProcessTrans(accessorXRef) : accessorXRef;
        commit('base/crud/setItems', [baseCrudKey, processedTransData], { root: true });
      }
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem getting List.', { root: true });
    }
  },
  async upsertAccessorXRef({ dispatch, rootGetters, commit }, { item, baseCrudKey }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.mutate({
        mutation: gql`mutation upsertAccessorXRef($item: accessorXRefInputType!)  {
          upsertAccessorXRef(upsert: $item) {
            ${fieldsToGqlString(fields)},
          }
        }`,
        variables: {
          item,
        },
      });
      clients.handleGQLErrors(results, commit);
      const taxData = rootGetters['base/crud/items'](baseCrudKey);
      const newTaxUnit = results.data.upsertAccessorXRef;
      const newList = mergeByIdNewAtTop(taxData || [], newTaxUnit);
      commit('base/crud/setItems', [baseCrudKey, newList], { root: true });
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem in upserting the assessor x-ref List', { root: true });
    }
  },
  async deleteAccessorXRef({ commit, rootGetters, dispatch }, { item, baseCrudKey }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.mutate({
        mutation: gql`mutation deleteAccessorXRef ($id: ID!)  {
          deleteAccessorXRef(id: $id) {
                _id
              }
            }`,
        variables: {
          id: item._id,
        },
      });
      clients.handleGQLErrors(results, commit);
      const delId = results.data.deleteAccessorXRef._id;
      const taxData = rootGetters['base/crud/items'](baseCrudKey);
      const updatedData = taxData.filter((d) => d._id !== delId);
      commit('base/crud/setItems', [baseCrudKey, updatedData], { root: true });
      commit('base/crud/setIsVisible', [baseCrudKey, false], { root: true });
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem deleting the assessor x-ref', { root: true });
    }
  },
};

export default assessorXRefActions;
